import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCYWAslP6saTETxpIeorz0S4MNwCOxodqU",
  authDomain: "brija-c77c8.firebaseapp.com",
  projectId: "brija-c77c8",
  storageBucket: "brija-c77c8.appspot.com",
  messagingSenderId: "194287624843",
  appId: "1:194287624843:web:25524894184d5d9462ea8e",
};

// VAPID Key
const vapidKey = "BCYYXt1yhekVq4dgop8qt3kl3634qUoQg2SJqEfr6vqOBIFOGdizbhvL-dCiGOLxD-RO9lVOhRy2s41W5FX8Rxc";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// ---------------------------------------------------------------------
// IMPORTANT: firebase-messaging-sw.js no longer exists — FCM is now
// handled inside the main service-worker.js (see the SW merge). When
// serviceWorkerRegistration isn't passed explicitly, getToken() falls
// back to auto-registering '/firebase-messaging-sw.js' itself, which
// now 404s. Every getToken() call below must pass the registration
// for the SW that's actually controlling the page.
// ---------------------------------------------------------------------
const getActiveServiceWorkerRegistration = async () => {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service workers are not supported in this browser.');
  }
  return navigator.serviceWorker.ready;
};

// One-time migration: any token already cached by the browser was
// issued under the old, now-deleted firebase-messaging-sw.js
// registration and is permanently dead server-side (FCM returns
// messaging/registration-token-not-registered for it). The first time
// this runs after the merge ships, drop that stale registration
// before asking for a new one, so a fresh token gets issued under the
// current service worker instead of silently reusing the dead one.
const FCM_MIGRATION_FLAG = 'fcm-sw-merge-migrated-v1';

const migrateStaleTokenIfNeeded = async () => {
  if (localStorage.getItem(FCM_MIGRATION_FLAG) === 'true') return;

  try {
    await deleteToken(messaging);
  } catch (error) {
    // Non-fatal — there may be nothing to delete, or the old
    // registration is already gone. Either way, proceed to request a
    // fresh token below.
    console.warn('FCM token migration: deleteToken failed (continuing):', error);
  }

  localStorage.setItem(FCM_MIGRATION_FLAG, 'true');
};

/**
 * Get the current FCM token.
 * @returns {Promise<string>} The current token if successful.
 */
export const getCurrentToken = async () => {
  try {
    const swRegistration = await getActiveServiceWorkerRegistration();
    await migrateStaleTokenIfNeeded();

    const currentToken = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    });

    if (!currentToken) {
      throw new Error("Failed to generate the registration token.");
    }

    console.log("Client Token:", currentToken);
    return currentToken;
  } catch (error) {
    console.error("Error getting current FCM token:", error);
    throw error;
  }
};

/**
 * Listener for incoming messages.
 * @returns {Promise<object>} Resolves with the message payload.
 */
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Message received:", payload);
      resolve(payload);
    });
  });

/**
 * Request user permission for notifications and retrieve the FCM token.
 * @returns {Promise<string>} The FCM token if permission is granted.
 */
export const Sendrequest = async () => {
  console.log("Requesting user permission for notifications...");
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      throw new Error("User permission denied.");
    }
    console.log("Notification user permission granted.");

    const swRegistration = await getActiveServiceWorkerRegistration();
    await migrateStaleTokenIfNeeded();

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swRegistration,
    });

    if (!token) {
      throw new Error("Failed to generate the registration token.");
    }

    console.log("FCM Token:", token);
    return token;
  } catch (error) {
    console.error("Error during permission request or token retrieval:", error);
    throw error;
  }
};
